// extracted by mini-css-extract-plugin
export default {"container":"RankElement_container__+TIiB","description":"RankElement_description__7H0zs","pm":"RankElement_pm__w6dlH"};